import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 交货地点分页查询
export function getPurchaseAddressPageListApi(params) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/address/page`,
    method: 'get',
    params
  })
}

// 交货地点新增
export function addPurchaseAddressApi(data) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/address`,
    method: 'post',
    data
  })
}

// 交货地点修改
export function editPurchaseAddressApi(data) {
  const { addressId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/${addressId}/address`,
    method: 'put',
    data: other
  })
}

// 交货地点删除
export function deletePurchaseAddressApi(addressId) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/${addressId}/address`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 工厂编码查询
export function getPurchaseFactoryListApi() {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/address/factory/List`,
    method: 'get'
  })
}

// 交货地点查询
export function getPurchaseAddressByFactoryApi(factory) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-requirements/address/${factory}/List`,
    method: 'get'
  })
}
